import BaseController from "controllers/backend/base"
import { placesUri }  from "servos/googlePlaces"
import CreateAdminWidget from "widgets/backend/createAdminWidget"

import GeocompletedAddress from "widgets/geocompletedAddress"


class Controller extends BaseController {
  call() {
    super.call()
    bindAddressLocator.call(this);
  }
  scripts() {
    return [placesUri]
  }
};

var bindAddressLocator = function() {
  let elem = this.root.find('form')
  this.resultsFilter = new CreateAdminWidget(elem)
  new GeocompletedAddress({
    root: elem,
    options: {
      types: ['address'],
      country: 'AU'
    }
  });
};

export default Controller;
